/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewsArticle } from '../models/NewsArticle';
import type { NewsArticleUpdateDto } from '../models/NewsArticleUpdateDto';
import type { NewsDeleteRequest } from '../models/NewsDeleteRequest';
import type { NewsFeedEntry } from '../models/NewsFeedEntry';
import { request as __request } from '../core/request';

export class NewsService {

    /**
     * @returns NewsFeedEntry OK
     * @throws ApiError
     */
    public static async getNews(): Promise<Array<NewsFeedEntry>> {
        const result = await __request({
            method: 'GET',
            path: `/api/News`,
        });
        return result.body;
    }

    /**
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static async createNews(
requestBody?: NewsArticleUpdateDto,
): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/News`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody 
     * @returns NewsArticle OK
     * @throws ApiError
     */
    public static async updateNews(
requestBody?: NewsArticleUpdateDto,
): Promise<NewsArticle> {
        const result = await __request({
            method: 'PUT',
            path: `/api/News`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static async deleteNews(
requestBody?: NewsDeleteRequest,
): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/News`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param urlStub 
     * @returns NewsFeedEntry OK
     * @throws ApiError
     */
    public static async getNewsByStub(
urlStub: string,
): Promise<NewsFeedEntry> {
        const result = await __request({
            method: 'GET',
            path: `/api/News/${urlStub}`,
        });
        return result.body;
    }

}